function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  stroke: "null",
  id: "svg_1",
  d: "m0,0l16.94654,0l0,20.587036l-16.94654,0l0,-20.587036z",
  fill: "none"
}), React.createElement("path", {
  id: "svg_2",
  d: "m10.238508,0.306671l-8,0c-1.1,0 -1.99,0.9 -1.99,2l-0.01,16c0,1.1 0.89,2 1.99,2l12.01,0c1.1,0 2,-0.9 2,-2l0,-12l-6,-6zm-8,2l7,0l5,5l0,8.58l-1.84,-1.84c1.28,-1.94 1.07,-4.57 -0.64,-6.28c-0.97,-0.97 -2.24,-1.46 -3.52,-1.46c-1.28,0 -2.55,0.49 -3.53,1.46c-1.95,1.95 -1.95,5.11 0,7.05c0.97,0.97 2.25,1.46 3.53,1.46c0.96,0 1.92,-0.28 2.75,-0.83l2.85,2.86l-11.6,0l0,-16zm8.11,11.1c-0.56,0.56 -1.31,0.88 -2.11,0.88s-1.55,-0.31 -2.11,-0.88c-0.56,-0.56 -0.88,-1.31 -0.88,-2.11s0.31,-1.55 0.88,-2.11c0.56,-0.57 1.31,-0.88 2.11,-0.88s1.55,0.31 2.11,0.88c0.56,0.56 0.88,1.31 0.88,2.11s-0.31,1.55 -0.88,2.11z"
}));

var SvgEnRevisionIcon = function SvgEnRevisionIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEnRevisionIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/en_revision_icon.6bbc31f4.svg";
export { ForwardRef as ReactComponent };